import { Component, OnInit, ViewChild, HostListener, AfterContentInit } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort, Sort } from '@angular/material/sort';
import { Settings } from '../../../services/settings';
import { ServiceRequestType } from "../../../models/service-request-type";
import { ServiceRequestsService } from "../../../services/service-requests.service";
import { ValidationResult } from '../../../models/validation-result';
import {
	ConfirmDialogComponent,
	ConfirmDialogModel
} from '../../../components/shared/confirmation-dialog/confirmation-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { TransactionHistoryService } from '../../../services/transactionhistory.service';
import { TransactionHistoryComponent } from '../../../components/transaction-history/transaction-history';
import { DwUtils } from '../../../components/utils/dw-utils';
import { ServiceDefService } from "../../../services/servicedef.service";
import { UnitOfMeasure } from "../../../models/unit-of-measure";
import { NotesComponent } from 'src/app/components/notes/notes.component';
import { MessageService } from 'primeng/api';
import { MessageSuffix } from 'src/app/models/message-suffix';
import { MessageDefinitionService } from 'src/app/services/messages.service';
import { ServiceDef } from 'src/app/models/service-def';

export class UOMRec {
	id: string;
	description: string;
	constructor(id: string, desc: string) {
		this.id = id;
		this.description = desc;
	}
}
@Component({
	selector: 'app-message-suffixes',
	templateUrl: './message-suffixes.component.html',
	styleUrls: ['./message-suffixes.component.css']
})
export class MessageSuffixesComponent implements OnInit, AfterContentInit {

	/*** Header / Query Strip Variables ****/
	public formTitle = 'Message Suffixes';
	public pagination: string;
	/*** Editing variables ***/
	public isEditing: boolean | null = false;
	public records: any;
	public serviceRequestTypeList: ServiceRequestType[];
	public selectedRecord: ServiceDef;
	public historyRecord: MessageSuffix;
	public Idx: number | null = -1;
	public strErr: string | null = '';
	public dataSource: MatTableDataSource<any>;
	public requestStatusDataSource: MatTableDataSource<any>;
	public result: boolean | null = false;
	public disabledFlag: boolean | null = true;
	public uomList: any;
	public requestStatusList: any;
	visibleModify = false;

	/**** Query strip filter settings ***/
	public selectedStatusFilter: string | null = 'Active';
	public contentClassWithBanner: string | null = 'dwtable-container';
	public contentClassWithoutBanner: string | null = 'dwtable-container-without-header';
	public contentClassName: string | null = 'dwtable-container';

	/*** Record Table   ***/
	public displayedColumns: string[] = ['id', 'requestType', 'description', 'unitOfMeasure', 'activeStatus'];
	public displayedColumnsRequestStatus: string[] = ['id', 'shortDescription', 'lastUpdated', 'edit'];


	/***** Tab Detail Section *****/
	public selectedTabIndex: number | null = 0;

	selectedRequestStatus: any;
	selectedRequestStatusIdx = -1;
	isEditingRequestStatus: boolean = false;

	public id: any | null = '';

	public busyCursor: boolean = false;
	public messageBody: any | null = '';
	public activeStatus: any | null = ''
	messageBodyDlg = false;

	public messageSuffixList: MessageSuffix[] = [];
	public selectedMessageSuffix: MessageSuffix;
	showAllstatuses = false;
	showaRestrictedStatuses = false;

	@ViewChild('sort1', { static: true }) sort1: MatSort;
	// Bind the second table's MatSort instance
	@ViewChild('sort2', { static: true }) sort2: MatSort;
	@ViewChild('history', { static: true }) history: TransactionHistoryComponent;

	constructor(private serviceRequestsService: ServiceRequestsService,
		private serviceDefService: ServiceDefService,
		private messageService: MessageDefinitionService,
		private txService: TransactionHistoryService,
		public dialog: MatDialog) {
		this.selectedRecord = new ServiceDef();
	}

	ngOnInit() {
		if(Settings.getInstance().hasPrivilege('AGENCY_MESSAGE_SUFFIXES', "WRITE")) {
			this.visibleModify =true;
		}
		this.showAllstatuses = Settings.getInstance().hasPrivilege('AGENCY_MESSAGE_SUFFIXES_ALL', "SHOW");
		this.showaRestrictedStatuses = Settings.getInstance().hasPrivilege('AGENCY_MESSAGE_SUFFIXES_RESTRICTED', "SHOW");
	}

	ngAfterContentInit() {

		if (Settings.getInstance().enableMessageBanner) {
			this.contentClassName = this.contentClassWithBanner;
		} else {
			this.contentClassName = this.contentClassWithoutBanner;
		}

		this.serviceDefService.getActiveUnitOfMeasures().subscribe(
			(result) => {
				this.uomList = new Array();
				for (const rec of result) {
					this.uomList.push(new UOMRec(rec.description, rec.description));
				}
				//this.uomList = result;
				this.queryRecords();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'fetching UOMs')
			});
	}

	/*** Query Records from the Service ***/
	public queryRecords() {
		this.busyCursor = true;
		this.serviceRequestsService.getAllServiceRequestTypes().subscribe(
			(data) => {
				this.serviceRequestTypeList = data;
				this.queryServiceDefs();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Error: unable to retrieve request types data from the service');
				this.busyCursor = false;
			}
		);
	}
	queryServiceDefs() {
		this.serviceDefService.getAllServiceDefsForAgency(Settings.getInstance().loggedInUser.agencyId).subscribe(
			(data) => {
				this.records = data;
				for (let rec of this.records) {
					rec['requestType'] = this.lblServiceTypeDesc(rec.serviceRequestTypeId);
				}
				this.dataSource = new MatTableDataSource(this.records);
				this.dataSource.sort = this.sort1;
				this.setPagination(-1, this.dataSource.data.length);
				this.onChangeStatusFilterValue();
				this.queryMessageSuffixes();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Error: unable to retrieve service definitions from the server');
				this.busyCursor = false;
			}
		);
	}
	queryMessageSuffixes() {
		this.messageService.getAllMessageSuffixes().subscribe(
			(messagereponses) => {
				this.messageSuffixList = messagereponses;
				this.queryRequestStatuses();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Error: unable to retrieve message suffixes data from the service');
				this.busyCursor = false;
			}
		);
	}

	queryRequestStatuses() {
		this.serviceRequestsService.getAllRequestStatuses().subscribe(
			(requestStatuses) => {

				this.busyCursor = false;
				if(this.showAllstatuses) {
					this.requestStatusList = requestStatuses;
				} else if(this.showaRestrictedStatuses){
					this.requestStatusList = requestStatuses.filter(status => status.selectable===1);
				} else{
					this.requestStatusList = [];
					return;
				}
				this.requestStatusDataSource = new MatTableDataSource(this.requestStatusList);
				this.requestStatusDataSource = new MatTableDataSource(this.requestStatusList);
				this.requestStatusDataSource.sort = this.sort2;
				this.setPagination(-1, this.requestStatusDataSource.data.length);
				this.displayDetail(this.selectedRecord);
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Error: unable to retrieve request status data from the service');
				this.busyCursor = false;
			}
		);
	}


	/*** Display the number of records from the total ***/
	public setPagination(idx: number, total: number) {
		this.pagination = (idx + 1) + '/' + total;
	}

	public onChangeStatusFilterValue() {
		const dataTemp: ServiceDef[] = [];
		this.clearFilter();

		for (const rec of this.records) {
			if (rec.activeStatus === this.selectedStatusFilter || this.selectedStatusFilter === 'All') {
				dataTemp.push(rec);
			}
		}
		this.dataSource = new MatTableDataSource(dataTemp);
		this.setPagination(-1, this.dataSource.filteredData.length);
	}

	public onStatusChange() {

		this.serviceRequestsService.updateRequestType(this.selectedRecord).subscribe(
			() => {
				// no user feedback, just apply the filter ...
				this.onChangeStatusFilterValue();
			});
	}

	public doTabChange(event): void {
		if (event.index === 1 && this.selectedMessageSuffix) {
			this.history.onShowHandler('MessageSuffixes', 'id', this.selectedMessageSuffix.id.toString());
		}
	}

	@HostListener('matSortChange', ['$event'])
	public onSortChange(event: any) {
		if (event.direction === 'asc') {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					a[event.active] - (b[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					a[event.active].localeCompare(b[event.active]));
			}
		} else {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					b[event.active] - (a[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					b[event.active].localeCompare(a[event.active]));
			}
		}

		this.dataSource.data = this.records;
		this.onChangeStatusFilterValue();
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}

	@HostListener('matSortChange', ['$event'])
	public onSortChangeRequestStatus(event: any) {
		const sortDirection = event.direction === 'asc' ? 1 : -1;

		this.requestStatusList.sort((a, b) => {
			const aValue = a[event.active];
			const bValue = b[event.active];

			if (event.active === 'lastUpdated') {
				// Convert undefined to a date far in the past or future
				const aDate = aValue ? new Date(aValue) : new Date(0); // Treat undefined as the earliest date
				const bDate = bValue ? new Date(bValue) : new Date(0); // Treat undefined as the earliest date
				return (aDate.getTime() - bDate.getTime()) * sortDirection;
			} else if (typeof aValue === 'string' && typeof bValue === 'string') {
				return aValue.localeCompare(bValue) * sortDirection;
			} else if (typeof aValue === 'number' && typeof bValue === 'number') {
				return (aValue - bValue) * sortDirection;
			} else {
				// Handle cases where values might be of different types or undefined
				return 0;
			}
		});

		this.requestStatusDataSource.data = this.requestStatusList;
		this.setPagination(this.selectedRequestStatusIdx, this.requestStatusDataSource.filteredData.length);
	}

	public clearFilter() {
		if (this.isEditing) {
			return;
		}
		this.unSelectRow();
		this.dataSource.filter = '';
		this.selectRow();
		this.setPagination(-1, this.dataSource.data.length);
	}

	public applyFilter(filterValue: string) {
		this.dataSource.filter = filterValue.trim().toLowerCase();
		this.unSelectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}

	public selectRow() {
		if (this.selectedRecord.id === 0) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
	}

	public unSelectRow() {
		this.Idx = -1;
		this.selectedRecord = new ServiceDef();
		this.setPagination(this.Idx, this.dataSource.data.length);
		this.displayDetail(this.selectedRecord);
		this.clear();
	}

	public displayDetail(record: ServiceDef) {
		if (record === undefined) {
			return;
		}
		this.id = record.id;
		this.clearRequestStatusList();
		if (!this.requestStatusList) { return; }
		for (let i = 0; i < this.requestStatusList.length; i++) {
			const suffix: MessageSuffix = this.getMessageSuffixByServiceDefIdAndRequestStatus(record.id, this.requestStatusList[i].id);
			if (suffix) {
				this.requestStatusList[i]['lastUpdated'] = suffix.lastUpdated;
			}

		}


	}

	public clear() {
		this.id = '';
		this.activeStatus = undefined;
		this.messageBody = '';

	}


	public tableKeyDown(event: KeyboardEvent) {

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
				this.selectRow();
				this.displayDetail(this.selectedRecord);
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
				this.selectRow();
				this.displayDetail(this.selectedRecord);
			}
		}
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}

	public validateFields(): boolean {

		this.strErr = '';
		const vr: ValidationResult = this.selectedRecord.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}
		return true;
	}

	public submitRecord() {

		if (!this.selectedMessageSuffix) {
			this.selectedMessageSuffix = new MessageSuffix();
			this.selectedMessageSuffix.serviceDefId = this.selectedRecord.id;
			this.selectedMessageSuffix.agencyId = this.selectedRecord.agencyId;
			this.selectedMessageSuffix.requestTypeId = this.selectedRecord.serviceRequestTypeId;
			this.selectedMessageSuffix.requestStatusId = this.selectedRequestStatus.id;
		}
		this.selectedMessageSuffix.activeStatus = this.activeStatus;
		this.selectedMessageSuffix.messageSuffix = this.messageBody;
		if (this.selectedMessageSuffix.id > 0) {
			this.messageService.updateMessageSuffix(this.selectedMessageSuffix).subscribe(
				(data) => {
					this.isEditing = false;
					this.queryMessageSuffixes();
					this.txService.updateTransactionHistory(this.historyRecord, this.selectedMessageSuffix, 'MessageSuffixes', this.selectedMessageSuffix.id);
				},
				(error) => {
					this.strErr = 'Error: The server could not add/submit this record';
					return;
				}
			);
		} else {
			this.messageService.createMessageSuffix(this.selectedMessageSuffix).subscribe(
				(data) => {
					this.isEditing = false;
					this.selectedMessageSuffix.id = data.id;
					this.txService.createTransactionHistory('MessageSuffixes', this.selectedMessageSuffix.id, 'Create',
						'Created new Message Suffix', this.selectedMessageSuffix.messageSuffix,
						this.selectedRecord.description + '->' + this.selectedRequestStatus.shortDescription);
					this.queryMessageSuffixes();
				},
				(error) => {
					this.strErr = 'Error: The server could not add/submit this record';
					return;
				}
			);
		}

	}



	public onRowClicked(selected: any) {
		if (this.isEditing === true)
			return;
		this.selectedRecord = selected;
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
		this.selectedRequestStatus = undefined;
		this.selectedRequestStatusIdx = -1;
		this.clear();
		this.history.clearRecords();
		this.displayDetail(this.selectedRecord);
	}
	public cancelSubmitRecord() {
		this.strErr = '';
		this.isEditing = false;
		this.selectedMessageSuffix = this.historyRecord;
		this.displayDetail(this.selectedRecord);
	}

	onRequestStatusRowClicked(row: any) {
		if (!this.selectedRecord || this.selectedRecord.id === 0) {
			return;
		}
		if (this.isEditing === true)
			return;
		this.clear();
		this.selectedRequestStatus = row;
		this.selectedRequestStatusIdx = this.requestStatusList.indexOf(row);
		this.selectedMessageSuffix = this.getMessageSuffixByServiceDefIdAndRequestStatus(this.selectedRecord.id, this.selectedRequestStatus.id);
		if (this.selectedMessageSuffix) {
			this.messageBody = this.selectedMessageSuffix.messageSuffix;
			this.activeStatus = this.selectedMessageSuffix.activeStatus;
			this.history.onShowHandler('MessageSuffixes', 'id', this.selectedMessageSuffix.id.toString());
		} else {
			this.history.clearRecords();
		}

	}
	public getMessageSuffixByServiceDefIdAndRequestStatus(serviceDefId: number, requestStatusId: number): MessageSuffix | undefined {
		return this.messageSuffixList.find(
			suffix => suffix.serviceDefId === serviceDefId && suffix.requestStatusId === requestStatusId
		);
	}

	modifyRecord() {
		this.isEditing = true;
		// Create a deep clone of selectedMessageSuffix

		if (!this.selectedMessageSuffix || this.selectedMessageSuffix.id === 0 || this.selectedMessageSuffix.id === -1) {
			this.activeStatus = 'Active';
		} else {
			this.historyRecord = JSON.parse(JSON.stringify(this.selectedMessageSuffix));
		}

	}
	public clearRequestStatusList(): void {
		if (!this.requestStatusList) { return; }
		this.requestStatusList.forEach((status) => {
			status.lastUpdated = undefined;
		});
	}

	public doDialogMessageBody() {
		this.messageBodyDlg = true;
	}
	public doMessageDetailSubmit(event: any): void {
		this.messageBody = event;
		if (!this.activeStatus || this.activeStatus.length == 0)
			this.activeStatus = 'Active';
		this.messageBodyDlg = false;
	}

	public lblServiceTypeDesc(id: number): string {
		if (id === null) {
			return '';
		}
		let retVal;

		try {
			retVal = this.serviceRequestTypeList.find(s => s.id === id).description;
		} catch { return ''; }
		return retVal;
	}

	btnEditFromGridHandler() {
		if (!this.selectedRecord || this.selectedRecord.id === 0) {
			return;
		}
		this.modifyRecord();
		this.doDialogMessageBody();
	}

}
